import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { sportIds, leagueIds } from 'src/constants/personalizationIds'
import { videos } from 'src/constants/videos'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    video={videos.bkfc.videoUrl}
    title="Watch BKFC events with Fubo"
    subtitle="Catch action-packed bouts each month"
    networkSet="sports"
    customNetworks={['fsn']}
    showRSN={true}
    sportId={sportIds.Boxing}
    leagueId={leagueIds.BKFC}
  />
)
